<div class="tabs-wrapper">
  <ng-container *ngFor="let tab of tabs">
    <div
      *ngIf="tab.active"
      class="tabs-entry"
      [attr.data-at-remote-service-tab-btn]="tab.type"
      gtm="onSelectRemoteServiceTab"
      [gtmAction]="tab.title"
      gtmCategory="Select Remote Service tab"
      [class.selected]="tab.type === activeOverlay"
      (click)="onTabSelect(tab.type)"
    >
      {{ tab.title | translate }}
    </div>
  </ng-container>
</div>
